import React from "react"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import ChevronDown from "../svg/icons/IconChevronDown"

const NavBarMenuIntegrations = ({ showMenu, setShowMenu }) => {
  const { t } = useTranslation()

  return (
    <div className="menu">
      <Link
        to="/integrations/"
        className="nav-bar__btn"
        onClick={e => {
          e.preventDefault()
          setShowMenu()
        }}
      >
        <span>{t("navigation.integrations.nav-title")}</span>
        <ChevronDown
          className={`menu-icon ${showMenu ? "menu-icon__rotate" : ""}`}
        />
      </Link>
      <div
        className={`menu__mega-menu ${showMenu ? "menu__mega-menu--open" : ""}`}
      >
        {showMenu && (
          <>
            <div className="menu__mega-menu-container">
              <div className="menu__main">
                <div className="grid-4-col">
                  <Link
                    to="/integrations/quickbooks-crm/"
                    className="menu__item-link"
                  >
                    <span className="menu__item--integrations">
                      <img
                        src="/integration-svgs/quickbooks.svg"
                        alt="QuickBooks logo"
                        className="menu__item-logo"
                      />
                      <p className="menu__item-title">QuickBooks</p>
                    </span>
                  </Link>

                  <Link to="/integrations/gmail/" className="menu__item-link">
                    <span className="menu__item--integrations">
                      <img
                        src="/integration-svgs/gmail.svg"
                        alt="Gmail logo"
                        className="menu__item-logo"
                      />
                      <p className="menu__item-title">Gmail</p>
                    </span>
                  </Link>

                  <Link
                    to="/integrations/transpond/"
                    className="menu__item-link"
                  >
                    <span className="menu__item--integrations">
                      <img
                        src="/integration-svgs/transpond.svg"
                        alt="Transpond logo"
                        className="menu__item-logo"
                      />
                      <p className="menu__item-title">Transpond</p>
                    </span>
                  </Link>

                  <Link
                    to="/integrations/microsoft-365-outlook-crm/"
                    className="menu__item-link"
                  >
                    <span className="menu__item--integrations">
                      <img
                        src="/integration-svgs/outlook.svg"
                        alt="Outlook logo"
                        className="menu__item-logo"
                      />
                      <p className="menu__item-title">Outlook</p>
                    </span>
                  </Link>

                  <Link
                    to="/integrations/xero-crm/"
                    className="menu__item-link"
                  >
                    <span className="menu__item--integrations">
                      <img
                        src="/integration-svgs/xero.svg"
                        alt="Xero logo"
                        className="menu__item-logo"
                      />
                      <p className="menu__item-title">Xero</p>
                    </span>
                  </Link>

                  <Link
                    to="/integrations/zapier-crm/"
                    className="menu__item-link"
                  >
                    <span className="menu__item--integrations">
                      <img
                        src="/integration-svgs/zapier.svg"
                        alt="Zapier logo"
                        className="menu__item-logo"
                      />
                      <p className="menu__item-title">Zapier</p>
                    </span>
                  </Link>

                  <Link
                    to="/integrations/freshbooks-crm/"
                    className="menu__item-link"
                  >
                    <span className="menu__item--integrations">
                      <img
                        src="/integration-svgs/freshbooks.svg"
                        alt="Freshbooks logo"
                        className="menu__item-logo"
                      />
                      <p className="menu__item-title">FreshBooks</p>
                    </span>
                  </Link>

                  <Link to="/integrations/slack/" className="menu__item-link">
                    <span className="menu__item--integrations">
                      <img
                        src="/integration-svgs/slack.svg"
                        alt="Slack logo"
                        className="menu__item-logo"
                      />
                      <p className="menu__item-title">Slack</p>
                    </span>
                  </Link>

                  <Link
                    to="/integrations/freeagent-crm/"
                    className="menu__item-link"
                  >
                    <span className="menu__item--integrations">
                      <img
                        src="/integration-svgs/freeagent.svg"
                        alt="FreeAgent logo"
                        className="menu__item-logo"
                      />
                      <p className="menu__item-title">FreeAgent</p>
                    </span>
                  </Link>

                  <Link
                    to="/integrations/?collection=whatsapp"
                    className="menu__item-link"
                  >
                    <span className="menu__item--integrations">
                      <img
                        src="/integration-svgs/whatsapp.svg"
                        alt="WhatsApp logo"
                        className="menu__item-logo"
                      />
                      <p className="menu__item-title">WhatsApp</p>
                    </span>
                  </Link>

                  <Link to="/google-workspace-crm/" className="menu__item-link">
                    <span className="menu__item--integrations">
                      <img
                        src="/integration-svgs/google.svg"
                        alt="Google logo"
                        className="menu__item-logo"
                      />
                      <p className="menu__item-title">Google</p>
                    </span>
                  </Link>

                  <Link
                    to="/microsoft-365-integrations-crm/"
                    className="menu__item-link"
                  >
                    <span className="menu__item--integrations">
                      <img
                        src="/integration-svgs/microsoft.svg"
                        alt="Microsoft logo"
                        className="menu__item-logo"
                      />
                      <p className="menu__item-title">Microsoft</p>
                    </span>
                  </Link>
                </div>
                <Link
                  to="/integrations/"
                  className="menu__item-link menu__item-link--mobile text-link text-link--dark"
                >
                  <span className="menu__item--integrations ">
                    <p className="menu__item-title mt-4">
                      {t("navigation.integrations.side-section.link")}
                    </p>
                  </span>
                </Link>
              </div>
              <Link
                to="/integrations/"
                className="menu__aside menu__aside--integrations"
              >
                <p className="mb-0 h5 menu__aside-title text-link">
                  {t("navigation.integrations.side-section.title")}
                </p>
                <p className="mb-0 p--sm menu__aside-description">
                  {t("navigation.integrations.side-section.description")}
                </p>
                <p className="text-link text-link--light menu__aside-link">
                  {t("navigation.integrations.side-section.link")}
                </p>
              </Link>
            </div>
            <div className="menu__footer">
              <div className="menu__footer-container">
                <div className="menu__footer-links">
                  <Link
                    to="/integrations/"
                    className="text-link text-link--dark text-link--bare menu__footer-link menu__footer-link--tablet p--sm"
                  >
                    {t("navigation.integrations.side-section.link")}
                  </Link>
                  <a
                    className="text-link text-link--dark text-link--bare menu__footer-link p--sm"
                    href="https://developer.capsulecrm.com/"
                  >
                    {t("navigation.integrations.footer-link-1")}
                  </a>

                  <Link
                    className="text-link text-link--dark text-link--bare menu__footer-link p--sm"
                    to="/partner-program/technology/"
                  >
                    {t("navigation.integrations.footer-link-2")}
                  </Link>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default NavBarMenuIntegrations
